import { render } from "./OltList.vue?vue&type=template&id=6b809728"
const script = {}

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__